import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import { Cascader as AntdCascader } from "antd";

@autobind
/**
 *
 */
export default class Cascader extends Base {
  static propTypes = {
    ...Base.propTypes,
    items: PropTypes.array,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
    ]),
  };

  /**
   *
   * @return {XML|null}
   * @protected
   */
  get _props() {
    return this.props.$omit(["items"]);
  }

  /**
   *
   * @return {XML}
   */
  get _component() {
    return (
      <AntdCascader
        options={this.props.items}
        dir="auto"
        placeholder={app.translate("main.Please Select")}
      />
    );
  }
}
